import React, { useState } from "react";
import {
  shouldShowProgressReminder,
  markProgressCheckIn,
  snoozeReminder,
} from "../lib/memberIdentity";

const PROGRESS_FORM_URL = "https://integratedwellness.jotform.com/262077987278072";

// Weekly Progress Check-in reminder — shown on the Welcome screen only,
// to returning members whose last check-in anchor is 7+ days old.
export default function ProgressReminderBanner() {
  const [visible, setVisible] = useState(() => shouldShowProgressReminder());
  if (!visible) return null;

  const logProgress = () => {
    markProgressCheckIn();
    setVisible(false);
    window.open(PROGRESS_FORM_URL, "_blank", "noopener,noreferrer");
  };

  const snooze = () => {
    snoozeReminder();
    setVisible(false);
  };

  return (
    <div
      className="mb-10 fade-up p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6"
      style={{
        background: "var(--iw-blue-tint)",
        border: "1px solid var(--iw-blue)",
        borderLeft: "4px solid var(--iw-accent-red)",
        borderRadius: "2px",
      }}
      role="status"
      data-testid="progress-reminder-banner"
    >
      <div className="flex-1">
        <div
          className="serif text-lg sm:text-xl mb-1"
          style={{ color: "var(--iw-primary)", fontWeight: 700 }}
        >
          Ready for your weekly reset check-in?
        </div>
        <p className="text-[14px] leading-relaxed m-0" style={{ color: "var(--iw-body)" }}>
          Take about two minutes to log how your nervous system, sleep, stress, and
          recovery have changed.
        </p>
      </div>
      <div className="flex items-center gap-3 flex-shrink-0">
        <button
          type="button"
          className="iw-btn-primary"
          style={{ padding: "0.7rem 1.2rem", fontSize: "12px" }}
          onClick={logProgress}
          data-testid="progress-reminder-log-btn"
        >
          Log my progress <span aria-hidden="true">↗</span>
        </button>
        <button
          type="button"
          className="iw-btn-ghost"
          style={{ padding: "0.65rem 1rem", fontSize: "12px" }}
          onClick={snooze}
          data-testid="progress-reminder-snooze-btn"
        >
          Remind me tomorrow
        </button>
      </div>
    </div>
  );
}
